






























import { Component, Vue, Prop } from "vue-property-decorator";
import FoulingClient from "Clients/diagnostics-client";
import { HullCoating } from "@/types/HullCoating";

@Component
export default class HullCoatingIndicator extends Vue {
  @Prop({ required: false }) readonly vesselId!: number | null;
  @Prop({ default: true }) readonly showEdit!: boolean;

  hullCoating: HullCoating | null = null;
  loading = false;

  async mounted(): Promise<void> {
    if (!this.vesselId) return;
    this.loading = true;
    try {
      const data = await FoulingClient.hullCoatingVessel(this.vesselId);
      this.hullCoating = (data as HullCoating) ?? null;
    } catch (err) {
      this.hullCoating = null;
    } finally {
      this.loading = false;
    }
  }

  onEdit(): void {
    if (this.showEdit) this.$emit("edit");
  }
}
